import React from 'react'
import './Insight.css'
import Banner from './banner/Banner'
import Blogs from './blogs/Blogs'
import Eternal_Elements from '../home/eternal_elements/Eternal_Elements'
import Discover_Wallpaper_Banner from './discover_wallpaper_banner/Discover_Wallpaper_Banner'
import Gurudevs_Shorts from '../home/gurudevs_shorts/Gurudevs_Shorts'
import Gurujis_Pravachan from './gurujis_pravachan/Gurujis_Pravachan'
import Latest_Videos from './latest_videos/Latest_Videos'
import Latest_Audio from './latest_audio/Latest_Audio'
import Latest_Articles from './latest_articles/Latest_Articles'

const Insight = () => {
  return (
    <section className='Insight'>
        <Banner/>
        <Blogs/>
        <Eternal_Elements/>
        <Discover_Wallpaper_Banner/>
        <Gurudevs_Shorts/>
        <Gurujis_Pravachan/>
        <Latest_Videos/>
        <Latest_Audio/>
        <Latest_Articles/>
    </section>
  )
}

export default Insight
